import { registerAdditionalMessages } from "@hoppscotch/common/modules/i18n"
import enLocale from "../../locales/en.json"

/**
 * Initialize and register additional i18n translations specific to the selfhost-web package
 */
export function setupSelfhostI18n() {
  // Register English translations
  registerAdditionalMessages("en", enLocale)
}

/**
 * Dynamically load and register a locale file
 * This can be used for on-demand loading of additional languages
 *
 * @param locale The locale code to load (e.g., 'fr', 'es', etc.)
 */
export async function loadAdditionalLocale(locale: string): Promise<void> {
  try {
    // Dynamic import of locale file
    const localeModule = await import(`../../locales/${locale}.json`)

    if (localeModule.default) {
      registerAdditionalMessages(locale, localeModule.default)
    }
  } catch (error) {
    console.error(`Failed to load locale "${locale}" for selfhost-web:`, error)
  }
}
